"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoomiOrderResumeSubscriptionSchema = void 0;
const boomi_order_default_1 = require("./boomi-order-default");
const EVENT_INFO_DEFINITION = {
    properties: {
        autoRenewStatus: {
            type: 'boolean'
        },
        isTrial: {
            type: 'boolean'
        }
    },
    required: [
        'autoRenewStatus',
        'isTrial'
    ],
    type: 'object'
};
const EVENT_TYPE_DEFINITION = {
    enum: [
        'RESUME_SUBSCRIPTION'
    ],
    type: 'string'
};
exports.BoomiOrderResumeSubscriptionSchema = {
    ...boomi_order_default_1.BoomiOrderDefaultSchema,
    definitions: {
        ...boomi_order_default_1.BoomiOrderDefaultSchema.definitions,
        EventInfo: EVENT_INFO_DEFINITION,
        EventType: EVENT_TYPE_DEFINITION
    },
    properties: {
        ...boomi_order_default_1.BoomiOrderDefaultSchema.properties,
        eventInfo: {
            $ref: '#/definitions/EventInfo'
        },
        eventType: {
            $ref: '#/definitions/EventType'
        }
    }
};
//# sourceMappingURL=data:application/json;base64,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